import moment from 'moment';
import printJS from 'print-js';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addShipmentPostings, changeShipmentPostingMany } from '../../../actions/postings';
import { uiChangeShipmentMode } from '../../../actions/ui';
import PostingsApi from '../../../API/shipment/postings-api';
import ShipmentWorkApi from '../../../API/shipment/work-api';
import close from '../../../assets/media/icons/close.svg';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, ExportExcelFileButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../components/Basic/Table';
import { Text } from '../../../components/Basic/WrapsStyle';
import { MAP_SKLAD_RUS, WAREHOUSES } from '../../../constans';
import { formFullDate, setDateSolid } from '../../../utils';
import PostingLine from './PostingLine';
import styles from './styles.module.scss';

export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito'];;

const SKLAD_LIST = ['Не выбран', ...WAREHOUSES];

export const WIDTH_POSTING = [
  '150px', // 0
  '350px', // 1
  '200px', // 2
  '180px', // 3
  '180px', // 4
  '127px', // 5
  '120px', // 6
  '220px', // 7
  '90px', // 8
  '50px', // 9
  '100px', // 10
  '220px', // 11
  '72px', // 12
  '140px', // 13
  '160px', // 14
  '160px', // 15
  '180px', // 16
  '75px', // 17
];

const STATUSES = ['Не выбран', 'Нет в наличии', 'Резерв', 'Частичный резерв', 'Излишки', 'Не хватает'];

const STATUSES_ORDERS = ['Не выбран', 'Ожидает отгрузки', 'Доставляется', 'Продано', 'Отменено', 'Отменено клиентом'];

const STATUSES_ALTERS = [
  { name: 'Не выбран', value: null },
  { name: 'Другой город', value: 'city' },
  { name: 'Другой поставщик', value: 'provider' },
];


const SORT_TYPE = [
  { name: 'Не выбран', value: 'dokup' },
  { name: 'По цене', value: 'price_dokup' },
];

const FILTER = {
  0: 'dokup',
  1: 'dokup_awaiting_shipment',
  2: 'dokup_not_available',
  3: 'dokup_variance',
};

const MODES = ['Режим отгрузки', 'Режим докупов'];

const CalcWeekAgo = () => {
  const start = new Date();
  start.setTime(start.getTime() - 20 * 24 * 3600000); // 10 * 24
  return start;
};

const CalcFeatureTwoDay = () => {
  const start = new Date();
  start.setTime(start.getTime() + 2 * 24 * 3600000); // + 2 * 24
  return start;
};

let abortController = new AbortController();


function DokupPostingsPage() {
  const user = useSelector((store) => store.user);
  const [checkAll, setCheckAll] = useState(false);
  const [pdfFilePath, setPdfFilePath] = useState('');

  const shipmentMode = useSelector((store) => store.ui.shipment_mode) || 'Режим отгрузки';

  const [sklad, setSklad] = useState(SKLAD_LIST[0]);

  const [market, setMarket] = useState(MARKETS_LIST[0]);
  const [postingsPrint, setPostingsPrint] = useState({});
  const [productAltsMap, setProductAltsMap] = useState({});


  const [dokupDate, setDokupDate] = useState(null);
  const [period, setPeriod] = useState({ start: CalcWeekAgo(), end: CalcFeatureTwoDay() });

  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.focus();
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };

  const [inputRef, setInputFocus] = useFocus();

  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);

  const [show, setShow] = useState(20);
  const [search, setSearch] = useState('');

  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });
  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [status, changeStatus] = useState(STATUSES[0]);
  const [orderStatus, changeOrderStatus] = useState('Не выбран');
  const [shop, setShop] = useState('Все');
  const [productsMap, setProductsMap] = useState({});
  const [filterAlters, setFilterAlters] = useState(STATUSES_ALTERS[0]);
  const [sortType, setSortType] = useState(SORT_TYPE[0]);

  const { ids, byIds, map } = useSelector((store) => store.postings);
  const dispatch = useDispatch();

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const params = useMemo(() => {
    return {
      limit: parseInt(show),
      page,
      search: search.trim(),
      providerId: provider.id,
      tab: FILTER[tab],
      shop: shop === 'Все' ? undefined : shop.toLowerCase(),
      market: market === 'Не выбрана' ? undefined : market.toLowerCase(),
      skladName: sklad === 'Все' ? undefined : MAP_SKLAD_RUS[sklad],
      sortType: sortType.value,
      filterAlters: filterAlters.value,
      period: {
        startDate: period.start,
        endDate: period.end,
      },
      filters: {
        orderStatus: orderStatus === 'Не выбран' ? undefined : orderStatus,
        productsStatus: status === 'Не выбран' ? undefined : status,
        dokupDate,
      },
    };
  }, [tab, show, search, provider.id, market, shop, status, orderStatus, period, dokupDate, sklad, filterAlters, sortType]);

  const loadData = () => {

    abortController.abort(); // Cancel the previous request
    abortController = new AbortController();

    PostingsApi.getDokupPostings({ data: params, signal: abortController.signal })
      .then((res) => {

        const { postings, cardsMap = {}, productsMap = {}, all_count = {}, count, productAltsMap } = res;

        setCount(count);
        setProductAltsMap(productAltsMap);
        const ids = postings.map((item) => item.posting_number);
        postings.forEach((item) => (byIds[item.posting_number] = item));

        setProductsMap(productsMap);
        dispatch(addShipmentPostings({ byIds, ids, map: cardsMap }));
      })
      .catch(e => console.log());
  };

  const loadTabs = () => {

    PostingsApi.getTabsCount({ data: { ...params, pageName: 'dokup' } })
      .then((res) => {
        const { all_count = {} } = res;

        const { dokup, dokup_awaiting_shipment, dokup_not_available, dokup_variance } = all_count;
        setCountStock([dokup, dokup_awaiting_shipment, dokup_not_available, dokup_variance]);
      })
      .catch(e => console.log());
  };


  useEffect(() => {
    loadTabs()
  }, []);


  useEffect(() => {
    loadData();
  }, [params]);



  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isAdmin = isOwner || user.role === 'user';

  const changePrintStatus = async (numbers = [], s) => {
    await ShipmentWorkApi.changePrint({ data: { postingNumbers: numbers, isPrint: s } }).then((r) => {
      const p = r.postings;
      const changeByIds = {};
      p.forEach((item) => {
        changeByIds[item.posting_number] = item;
      });
      dispatch(changeShipmentPostingMany(changeByIds));
    });
  };

  useEffect(() => {
    setShop('Все');
  }, [market]);

  const changePostingPrint = (order_number) => {
    if (postingsPrint[order_number]) {
      const s = postingsPrint;
      delete s[order_number];
      setPostingsPrint({ ...s });
    } else {
      setPostingsPrint({ ...postingsPrint, [order_number]: true });
    }

    //setPostingsPrint({ ...postingsPrint, [order_number]: !postingsPrint[order_number] });
  };

  const printSticker = useCallback(
    async (order) => {
      const r = { postingNumbers: [order.posting_number] };

      let file = await ShipmentWorkApi.pickerScan({ data: { postingNumbers: [order.posting_number] } })

      printJS({
        printable: file,
        type: 'pdf',
        base64: true,
        showModal: false,
        onPrintDialogClose: () => {
          window.focus();
          setInputFocus();
        },
      });
      await changePrintStatus([order.posting_number], true);
      setInputFocus();
    },
    [pdfFilePath],
  );

  const modes = MODES;

  const calcDownloadedData = useCallback(
    (filter = '') => {
      const data = ids.map((id) => byIds[id]);

      let res = [];
      for (let i = 0; i < data.length; i++) {
        const order = data[i];
        for (let j = 0; j < order.products.length; j++) {
          const product = order.products[j];
          res.push({
            Площадка: order.shop,
            'Номер заказа': order.posting_number,
            Поставщик: product.dokup_provider,
            'Название товара': product.name,
            Артикул: product.provider_sku,
            Количество: product.common_quantity,
            'Статус товара': product.diff.status,
            'Не хватает': product.diff.value,
            Расхождение: product.shipment_diff,
            Комментарий: product.comment,
          });
        }
      }
      return res;
    },
    [ids],
  );

  return (
    <Content>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={['Все докупы', 'Ожидает отгрузки', 'Нет в наличии', 'Расхождения']}
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />

          <Row>
            <Select
              select={shipmentMode}
              list={modes}
              onSelect={(v) => dispatch(uiChangeShipmentMode(v))}
              width="150px"
            />
          </Row>
        </Row>
        <Input
          value={search}
          ref={inputRef}
          onBlur={(v) => setSearch(v)}
          onClickEnter={(v) => setSearch(v)}
          label="Поиск"
        />
        <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

        <Row spaceBetween={true}>
          <Row style={{ height: '40px' }}>
            <Select
              label="Показать на странице"
              select={show}
              list={['20', '50', '100', '150', '200', '500', '1000']}
              onSelect={(v) => setShow(v)}
              width="150px"
              style={{ marginRight: '15px' }}
            />
            <Select
              list={MARKETS_LIST}
              select={MARKETS_LIST[0]}
              label="Площадка"
              onSelect={(v) => setMarket(v)}
              width={'150px'}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Поставщик"
              select={provider}
              valueFn={(p) => p.name}
              list={providers}
              width="200px"
              onSelect={(v) => changeProvider(v)}
              style={{ marginRight: '15px' }}
            />
            <Select
              list={SKLAD_LIST}
              select={sklad}
              label="Склад отгрузки"
              onSelect={(v) => setSklad(v)}
              width={'200px'}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Статус товара"
              select={status}
              list={STATUSES}
              width="200px"
              onSelect={(v) => changeStatus(v)}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Статус заказа"
              select={orderStatus}
              list={STATUSES_ORDERS}
              width="200px"
              style={{ marginRight: '15px' }}
              onSelect={(v) => changeOrderStatus(v)}
            />

            <Select
              label="Фильтр перекуп"
              select={filterAlters}
              valueFn={(p) => p.name}
              list={STATUSES_ALTERS}
              width="200px"
              style={{ marginRight: '15px' }}
              onSelect={(v) => setFilterAlters(v)}
            />

            <Select
              label="Сортировка"
              select={sortType}
              valueFn={(p) => p.name}
              list={SORT_TYPE}
              width="200px"
              style={{ marginRight: '15px' }}
              onSelect={(v) => setSortType(v)}
            />

            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Дата прихода</InputLabel>
              <Row style={{ position: 'relative', width: '150px' }}>
                <DateInput value={dokupDate && new Date(moment(dokupDate).add(new Date().getTimezoneOffset() / 60, 'h')) || ''} className={styles.calendar} onChange={(v) => setDokupDate(setDateSolid(v))} />
                <Button className={styles.close_button} onClick={() => setDokupDate(null)}>
                  <img src={close} style={{ width: '15px' }} />
                </Button>
              </Row>
            </Column>
          </Row>

          <Row style={{ alignItems: 'flex-end' }}>
            <ExportExcelFileButton
              filename={`Заказ общий ${formFullDate(new Date())}`}
              data={{
                Докупы: calcDownloadedData(),
              }}
              buttonTitle="Скачать данные"
              style={{ marginRight: '20px' }}
            />
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Начало периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={period.start}
                  className={styles.calendar}
                  onChange={(v) => setPeriod({ ...period, start: new Date(v) })}
                />
              </Row>
            </Column>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Конец периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={period.end}
                  className={styles.calendar}
                  onChange={(v) => setPeriod({ ...period, end: new Date(v) })}
                />
              </Row>
            </Column>
          </Row>
        </Row>
      </WhiteBlock>

      <Table styles={styles.table}>
        <TableHeader whiteHeader>
          {shipmentMode === modes[0] && (
            <>
              <HeaderTitle width={WIDTH_POSTING[8]} centerText={true}>Стикер</HeaderTitle>
              <HeaderTitle width={WIDTH_POSTING[0]}>Номер заказа</HeaderTitle>
              <HeaderTitle width={WIDTH_POSTING[12]} centerText>Дата отгрузки</HeaderTitle>
            </>
          )}
          {shipmentMode === modes[1] && (
            <HeaderTitle width={WIDTH_POSTING[0]} centerText>Дата отгрузки / маркетплейс</HeaderTitle>
          )}
          <HeaderTitle width={WIDTH_POSTING[1]}  centerText>
            Позиции в заказе
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[8]} centerText={true}>
            Кол-во
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[15]} centerText={true}>
            Статус заказа
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[14]} centerText={true}>
            Статус товара
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[8]} centerText={true}>
            Склад
          </HeaderTitle>

          {shipmentMode !== modes[0] && (
            <>
              <HeaderTitle width={WIDTH_POSTING[14]} centerText={true}>
                Артикул поставщика
              </HeaderTitle>
              <HeaderTitle width={WIDTH_POSTING[17]} centerText={true}>
                Цена
              </HeaderTitle>
              <HeaderTitle width={'100px'} centerText={true}>
                ДГ
              </HeaderTitle>
              <HeaderTitle width={'100px'} centerText={true}>
                ДП
              </HeaderTitle>
              <HeaderTitle width={WIDTH_POSTING[3]} centerText={true}>
                Статус повторного заказа
              </HeaderTitle>
            </>
          )}

          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
            Поставщик
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[13]} centerText={true}>
            Дата прихода на склад
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[11]} centerText={true}>
            Расхождение при отгрузке
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[16]} centerText={true}>
            Комментарий
          </HeaderTitle>
        </TableHeader>
        {ids.map((order) => {
          return (
            <PostingLine
              isAdmin={isAdmin}
              MODES={modes}
              shipmentMode={shipmentMode}
              order={byIds[order]}
              map={map}
              productsMap={productsMap}
              key={byIds[order].posting_number}
              productAltMap={productAltsMap}
              setInputFocus={setInputFocus}
              postingsPrint={postingsPrint}
              printSticker={printSticker}
              changePostingPrint={changePostingPrint}
              changePrintStatus={changePrintStatus}
              PROVIDERS_NAMES={providers.map((p) => p.name)}
              providers={providers}
            />
          );
        })}
      </Table>
      <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />
    </Content>
  );
}

export default DokupPostingsPage;
